// extracted by mini-css-extract-plugin
export var backContainer = "listGdd-module--back-container--1b094";
export var backLink = "listGdd-module--back-link--9b517";
export var backToSite = "listGdd-module--back-to-site--69c2a";
export var imgLogo = "listGdd-module--img-logo--1ec37";
export var listGdd = "listGdd-module--list-gdd--32cce";
export var titleGdd = "listGdd-module--title-gdd--51730";